import React from 'react';
import { PrivateMeetingSessionDetailsResponseType } from '../../../../lib/api';
import { CardComponent } from './Card';
import { EventType } from '../LayoutWrapper';
import { inc } from './CarouselWrapper';

interface ICarouselByGridProps {
  meetings: PrivateMeetingSessionDetailsResponseType[];
  event: EventType;
  eventToken: string;
  transformedTimeZone: string;
  onSubscriptionChange?: (meetingId: string, subscribed: boolean) => void;
}

const CarouselByGrid = ({
  meetings,
  event,
  eventToken,
  transformedTimeZone,
  onSubscriptionChange
}: ICarouselByGridProps): JSX.Element => {

  return (
    <div className='flex flex-wrap items-start -mt-4 pl-8 grid-card'>
      {meetings.map((meeting, i) => (
        <CardComponent
          meeting={meeting}
          index={i + inc}
          event={event}
          key={meeting.meetingId}
          eventToken={eventToken}
          transformedTimeZone={transformedTimeZone}
          onSubscriptionChange={onSubscriptionChange}
        />
      ))}
    </div>
  );
};

export default CarouselByGrid;
